

























































/**
 * 首页展示十首歌曲的列表
 */
import {Vue, Component, Prop} from 'vue-property-decorator';
import { PlayList, PlayListTrack } from '@/interfaces';
import { ABAction } from '@/stores/audioBar';

@Component
export default class RankList extends Vue {
  @Prop({
    type: String,
    required: true,
    // https://binaryify.github.io/NeteaseCloudMusicApi/#/?id=%E6%8E%92%E8%A1%8C%E6%A6%9C
    default: '3',
  }) public topType!: string;

  public playList: PlayList | null = null;

  get Tracks(): PlayListTrack[] {
    const arr: PlayListTrack[] = this.getListProp('tracks', []);
    return arr.length > 10 ? arr.slice(0, 10) : arr;
  }

  get Link() {
    return `/discover/toplist?id=${this.getListProp('id', '')}`;
  }

  public getListProp(prop: string, d: any) {
    return this.$u.getProp(this.playList, prop, d);
  }

  /**
   * 播放全部歌单
   */
  public handleClickPlayAll() {
    const id = this.getListProp('id', '');
    if (id) {
      this.$store.dispatch(ABAction('startPlayNewList'), { id });
    }
  }

  /**
   * 点击播放单首歌曲
   */
  public handleClickSingleSong(track: PlayListTrack) {
    this.$store.dispatch(ABAction('playANewSong'), track);
  }

  /**
   * 点击添加歌曲
   */
  public handleClickAddSong(track: PlayListTrack) {
    this.$store.dispatch(ABAction('addSongToList'), track);
  }

  public mounted() {
    this.$u.get(`/top/list?idx=${this.topType}`)
      .then((res) => {
        this.playList = res.failMark ? null : res.playlist;
      });
  }
}
